import React from 'react';

import { CSSTransition } from 'react-transition-group';
import './styles.css';
import {ANIMATION_TIMEOUT_APPEAR} from '../../../../constants/animation';
import BillingSection from './sections/BillingSection';
import CandidateNotificationsSection from './sections/CandidateNotificationsSection';
import PreferencesSection from './sections/PreferencesSection'
import RecruiterNotificationsSection from './sections/RecruiterNotificationsSection'
import PrivacySection from './sections/PrivacySection'
import SecuritySection from './sections/SecuritySection'
import SubscriptionSection from './sections/SubscriptionSection';

const AccountSettingsForm = props => {
  const { user, nextEmail, history, globalOptions, sections, activeSection, activeSubSection } = props;

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner">
        {activeSection === 'preferences' && (
          <PreferencesSection nextEmail={nextEmail} sections={sections} user={user} globalOptions={globalOptions} />
        )}
        {activeSection === 'notifications' && (
          <CandidateNotificationsSection sections={sections} user={user} history={history} />
        )}
        {activeSection === 'recruiter-notifications' && (
          <RecruiterNotificationsSection sections={sections} user={user} history={history} activeSubSection={activeSubSection} />
        )}
        {activeSection === 'privacy' && (
          <PrivacySection sections={sections} user={user} />
        )}
        {activeSection === 'security' && (
          <SecuritySection sections={sections} />
        )}
        {activeSection === 'subscription' && (
          <SubscriptionSection sections={sections} />
        )}
        {activeSection === 'billing' && (
          <BillingSection sections={sections} />
        )}
      </div>
    </CSSTransition>
  );
};

export default AccountSettingsForm;
